import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './Login.css';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setIsLoading(true);

    if (!email) {
      setError('กรุณากรอกอีเมล');
      setIsLoading(false);
      return;
    }

    try {
      const response = await api.post('/api/customer/forgot-password', { email });
      setSuccessMessage(response.data?.message || 'เราได้ส่งรหัส OTP ไปที่อีเมลของคุณแล้ว');
      setTimeout(() => {
        navigate('/reset-password', { state: { email } });
      }, 2000);
    } catch (error) {
      console.error('Forgot password error:', error);
      const message = error.response?.data?.error || 'ไม่สามารถส่งรหัส OTP ได้ กรุณาลองใหม่อีกครั้ง';
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <section className="login-showcase" aria-hidden="true">
        <div className="login-showcase-overlay" />
        <div className="login-showcase-content">
          <h1>ลืมรหัสผ่าน</h1>
          <p>กรุณากรอกอีเมลที่ใช้สมัครสมาชิก เราจะส่งรหัส OTP ไปให้คุณเพื่อรีเซ็ตรหัสผ่าน</p>
          <div className="login-showcase-meta">
            <div>
              <i className="bi bi-shield-lock" />
              <span>ปลอดภัย</span>
            </div>
            <div>
              <i className="bi bi-envelope-check" />
              <span>ยืนยันอีเมล</span>
            </div>
          </div>
        </div>
      </section>

      <section className="login-form-area">
        <div className="login-form-shell">
          <div className="login-brand-icons">
            <i className="bi bi-box" />
            <i className="bi bi-house-door" />
          </div>

          <div className="login-card">
            <header className="login-card-header">
              <h2>ลืมรหัสผ่าน</h2>
              <p>กรุณากรอกอีเมลของคุณ</p>
            </header>

            {successMessage && (
              <div className="login-alert login-alert--success" role="status">
                <span>{successMessage}</span>
              </div>
            )}

            {error && (
              <div className="login-alert" role="alert">
                <span>{error}</span>
                <button
                  type="button"
                  onClick={() => setError('')}
                  className="login-alert-dismiss"
                  aria-label="ปิดข้อความแจ้งเตือน"
                >
                  <i className="bi bi-x-lg" />
                </button>
              </div>
            )}

            <form className="login-form" onSubmit={handleSubmit}>
              <label className="login-field">
                <span>อีเมล</span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="login-input"
                  autoComplete="email"
                  disabled={isLoading}
                />
              </label>

              <button
                type="submit"
                className="login-submit-btn"
                disabled={isLoading}
              >
                {isLoading ? 'กำลังส่งรหัส OTP...' : 'ส่งรหัส OTP'}
              </button>
            </form>

            <div className="login-secondary-actions">
              <button
                type="button"
                className="login-secondary-btn"
                onClick={() => navigate('/login')}
              >
                กลับไปหน้าเข้าสู่ระบบ
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

